import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import PlaceCard from './../../components/placeCard/PlaceCard';
import BackArrow from './../../assets/img/back-icon.svg';
import styles from './PlacesListScreen.module.css';
import NavigationBar from './../../components/navigationBar/NavigationBar';
import {getDistanceFromPoints} from './../../utils/Utils';
import { FormattedMessage } from 'react-intl';

class PlacesListScreen extends Component {

    constructor(props){
        super(props);
        this.navBarRef = React.createRef();
        this.state = {
            pageTransitionEnd: false,
            searchInput: "",
            searchAnimation: "hidden",
        }

        window.scrollTo(0, 0);

        this.backTo = this.backTo.bind(this);
        this.animationEnd = this.animationEnd.bind(this);
        this.renderCards = this.renderCards.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.goToPlaceDetails = this.goToPlaceDetails.bind(this);
    }

    componentDidMount(props){
        window.onscroll = function(){
            if(window.pageYOffset <= 50 && this.state.searchAnimation === "open"){
                this.setState({
                    searchAnimation: "close"
                });
            }
            if(window.pageYOffset > 50 && this.state.searchAnimation !== "open"){
                this.setState({
                    searchAnimation: "open"
                });
            }
            if(this.navBarRef.current){
                this.navBarRef.current.showHide(window.pageYOffset);
            }
        }.bind(this);
    }

    goToPlaceDetails(placeId) {
        this.props.history.push({
            pathname: '/placeDetails/' + placeId,
            state: {
                animation: "slideInRight"
            }
        });
    }

    onSearch(e) {
        this.setState({
            searchInput: e.target.value
        });
    }

    backTo(){
        this.props.history.push({
            pathname: "/home",
            state: {
                animation: "slideInLeft"
            }
        });
    }

    animationEnd() {
        this.setState({
            pageTransitionEnd: true
        });
    }

    calculateDistance(place) {
        if(place.location && this.props.coords) {
            let userLat = this.props.coords.lat;
            let userLong = this.props.coords.long;
            let placeLat = place.location.lat;
            let placeLong = place.location.lng;
            let distance = getDistanceFromPoints(userLat, userLong, placeLat, placeLong);

            return distance;
        }
    }

    renderCards() {
        if(this.props.place){
            let places = this.props.place.list;

            places.forEach(place => {
                place.distance = this.calculateDistance(place);
            });

            return places
                .filter(place => place.name.toLowerCase().includes(this.state.searchInput.toLowerCase()))
                .sort((a, b) => {return a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0;})
                .map((place, i) => {
                return (
                    <PlaceCard  key={i}
                                onClick={() => this.goToPlaceDetails(place.id)}
                                coords={this.props.coords}
                                resize="828x793"
                                className={styles.card}
                                cardInfo={place}/>
                );
            });
        }
    }

    render() {
        let animation, searchAnimation = "";
        if(!this.state.pageTransitionEnd && this.props.location.state && this.props.location.state.animation){
            animation = "animated " + this.props.location.state.animation;
        }
        if(this.state.searchAnimation === "open"){
            searchAnimation = "animated slideInDown";
        }
        if(this.state.searchAnimation === "close"){
            searchAnimation = "animated slideOutUp";
        }

        let title = "";
        if(this.props.place){
            switch(this.props.place.title){
                case "Centros Culturais":
                    title = <FormattedMessage id="culturalPlaces" />;
                    break;

                case "Atrativos Naturais":
                    title = <FormattedMessage id="naturalPlaces" />;
                    break;

                default:
                    title = this.props.place.title;
            }
        }

        let topBar;
        if(this.state.searchAnimation !== "hidden"){
            topBar = (
                <div className={[styles.topBar, searchAnimation].join(' ')}>
                    <h4 className={[styles.topTitle, "h4Bold"].join(' ')}>
                        {title}
                    </h4>
                </div>
            );
        }

        return (
            <div>
                <ReactSVG onClick={this.backTo} src={BackArrow} className={styles.backButton}/>
                {topBar}
                <div className={animation} onAnimationEnd={this.animationEnd}>
                    <div className={styles.cardsContainer}>
                        <h2>{title}</h2>
                        {this.renderCards()}
                    </div>
                    <NavigationBar history={this.props.history} ref={this.navBarRef} active={"explore"}/>
                </div>
            </div>
        );
    }

}

export default PlacesListScreen;